export const minPartLitHelp = 'Min participation across Lit markets';
export const maxPartLitHelp = 'Max participation across Lit markets';
export const startTimeHelp = 'Timestamp of the first bin with allocated shares';
export const endTimeHelp = 'Timestamp after the last bin with allocated shares';
export const totalCostHelp =
    'Average expected trade cost for the target quantity in basis points';
export const riskHelp =
    'Standard deviation of price variation over the order duration (risk in basis points, weighted by our normalised schedule)';
